import React, { useEffect, Fragment, useState } from 'react';
import { View, UIManager, LayoutAnimation, TouchableWithoutFeedback } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import {
  isString as _isString,
  isEmpty as _isEmpty,
  map as _map,
  isFunction as _isFunction,
} from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';

import { VFText, VFButton } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { DateCurrencyFromatter } from '@vfgroup-oneplatform/foundation/Utils';

import { getThemeColors } from '../../../Themes';
import MyPlanInfoItem from '../MyPlanInfoItem';
import MyPlanItem from '../MyPlanItem';
import MyPlanUsageItem from '../MyPlanUsageItem';

import styles from './MyPlanCard.Styles';

const CustomLayoutAnimation = {
  duration: 150,
  create: {
    type: LayoutAnimation.Types.linear,
    property: LayoutAnimation.Properties.opacity,
  },
  update: {
    type: LayoutAnimation.Types.easeInEaseOut,
  },
};

const MyPlanCard = ({
  status,
  statusStyle,
  price,
  priceUnit,
  style,
  children,
  statusAccessibilityLabel,
  titleStyle,
  titleAccessibilityLabel,
  title,
  cardRightText,
  renewalDate,
  renewalDateStyle,
  cardRightTextStyle,
  usageData,
  contractData,
  onAddUsagePress,
  withUsagePercentage,
  withUpgradePlanCTA,
  images,
  percentageIndicatorFillColor,
  percentageIndicatorSecondaryColor,
  percentageIndicatorContainerStyle,
  percentageIndicatorShouldAnimate,
  customPlanCTAs,
  toggleAddUsageModal,
  onPressUpgradePlan,
  theme,
}) => {
  const [isShowMoreOpen, toggleShowMore] = useState(false);
  const { dateFormats, dateTransformer, currencyTransformer } =
    DateCurrencyFromatter.dateCurrencyFromatter;

  // DEPRECATEME: since [Release 20]
  const isOldMyPlan =
    !_isEmpty(usageData) && Array.isArray(usageData) && usageData[0]?.usageItemLabel;

  useEffect(() => {
    if (isOldMyPlan) {
      console.warn(
        'mapMyPlanResponse() in Services is deprecated, please use the new mapper mapMobilePlanResponse() instead',
      );
    }
  }, [isOldMyPlan]);

  const frameworkColors = getThemeColors(theme);

  const renderRightText = () => {
    return _isString(cardRightText) ? (
      <VFText
        style={[styles.renewalDateStyle(theme), cardRightTextStyle]}
        i18nKey={cardRightText}
      />
    ) : (
      renderRenewalDateText()
    );
  };

  const renderRenewalDateText = () => {
    if (moment(renewalDate).isValid()) {
      return (
        <VFText
          style={[styles.renewalDateStyle(theme), renewalDateStyle]}
          i18nKey="my_plan_primary_card_header_renewal_date"
          placeHolders={[dateTransformer(renewalDate, dateFormats.ordinalShortDate)]}
        />
      );
    }
  };

  const handleAddUsageButtonPress = item => {
    if (_isFunction(onAddUsagePress)) {
      onAddUsagePress(item, toggleAddUsageModal);
    } else {
      toggleAddUsageModal(item.key);
    }
  };

  const renderOldMyPlanItem = item => {
    const {
      usageItemLabel,
      usageValuesText,
      usageValuesPlaceholders,
      isUnlimitedUsage,
      addUsageButtonTitle,
      icon,
      shouldShowAddUsageButton,
      usagePercentageValue,
    } = item;
    return (
      <MyPlanUsageItem
        key={usageItemLabel}
        usageItemLabel={usageItemLabel}
        usageValuesText={usageValuesText}
        usageValuesPlaceholders={usageValuesPlaceholders}
        isUnlimitedUsage={isUnlimitedUsage}
        unlimitedUsageText={'my_plan_primary_card_unlimited_consumption'}
        addUsageButtonTitle={addUsageButtonTitle}
        withUsagePercentage={withUsagePercentage}
        icon={icon}
        shouldShowAddUsageButton={shouldShowAddUsageButton}
        usagePercentageValue={usagePercentageValue}
        containerStyle={styles.usageItemsContainerStyle}
        images={images}
        addUsageButtonHandler={() => handleAddUsageButtonPress(item)}
        percentageIndicatorFillColor={percentageIndicatorFillColor}
        percentageIndicatorSecondaryColor={percentageIndicatorSecondaryColor}
        percentageIndicatorContainerStyle={percentageIndicatorContainerStyle}
        percentageIndicatorShouldAnimate={percentageIndicatorShouldAnimate}
      />
    );
  };

  const renderUsage = _usageData => {
    if (_isEmpty(_usageData) || !Array.isArray(_usageData)) {
      return null;
    }

    return (
      <View style={styles.usageValuesView}>
        {_map(_usageData, item => {
          return isOldMyPlan ? renderOldMyPlanItem(item) : renderMyPlanItem(item);
        })}
      </View>
    );
  };

  const renderMyPlanItem = item => {
    const {
      containerStyle: itemContainerStyle,
      leftText,
      rightText,
      rightTextContainerStyle,
      addUsageButtonTitle,
      icon,
      shouldShowAddUsageButton,
      percentageValue,
      rightTextPlaceHolders,
      withIconBackground,
      withPercentageText,
      iconSize,
      leftTextStyle,
      rightTextStyle,
      percentageTextStyle,
      RightComponent,
      LeftComponent,
      addUsageButtonType,
      addUsageButtonTextStyle,
    } = item;
    return (
      <MyPlanItem
        key={leftText}
        containerStyle={[styles.usageItemsContainerStyle, itemContainerStyle]}
        icon={icon}
        withIconBackground={withIconBackground}
        images={images}
        leftText={leftText}
        rightText={rightText}
        rightTextContainerStyle={rightTextContainerStyle}
        iconSize={iconSize}
        leftTextStyle={leftTextStyle}
        rightTextStyle={rightTextStyle}
        percentageTextStyle={percentageTextStyle}
        RightComponent={RightComponent}
        LeftComponent={LeftComponent}
        addUsageButtonType={addUsageButtonType}
        addUsageButtonTextStyle={addUsageButtonTextStyle}
        rightTextPlaceHolders={rightTextPlaceHolders}
        withPercentageText={withPercentageText}
        percentageIndicatorFillColor={percentageIndicatorFillColor}
        percentageIndicatorSecondaryColor={percentageIndicatorSecondaryColor}
        percentageIndicatorContainerStyle={percentageIndicatorContainerStyle}
        percentageIndicatorShouldAnimate={percentageIndicatorShouldAnimate}
        percentageValue={percentageValue}
        addUsageButtonTitle={addUsageButtonTitle}
        onAddUsageButtonPress={
          shouldShowAddUsageButton ? () => handleAddUsageButtonPress(item) : undefined
        }
      />
    );
  };

  const renderPrice = (_price, _priceUnit) => {
    if (!_price) {
      return null;
    }

    return (
      <View style={styles.priceDetailsViewStyle}>
        <VFText i18nKey={'my_plan_primary_card_price_label'} style={styles.priceLabelStyle} />
        <View style={styles.priceValueViewStyle}>
          <VFText i18nKey={currencyTransformer(_price, 0)} style={styles.priceValueAmountStyle} />
          <VFText i18nKey={_priceUnit} style={styles.priceValueUnitStyle} />
        </View>
      </View>
    );
  };

  const renderContractData = _contractData => {
    if (_isEmpty(_contractData)) {
      return null;
    }
    return _map(_contractData, (item, index) => {
      const { key, value } = item;
      if (index < 2) {
        return <MyPlanInfoItem label={key} value={value} key={index} />;
      }
    });
  };

  const renderCustomPlanCTAs = _customPlanCTAs => {
    if (Array.isArray(_customPlanCTAs)) {
      return _map(_customPlanCTAs, cta => <VFButton {...cta} />);
    }
  };

  const renderMyPlanCTAs = (_withUpgradePlanCTA, _customPlanCTAs, _onPressUpgradePlan) => {
    if (!_withUpgradePlanCTA && _isEmpty(_customPlanCTAs)) {
      return null;
    }

    return (
      <>
        {_withUpgradePlanCTA && (
          <VFButton
            title="my_plan_primary_card_upgrade_plan"
            type="primary"
            style={styles.upgradeButtonStyle}
            onPress={_onPressUpgradePlan}
          />
        )}
        {renderCustomPlanCTAs(_customPlanCTAs)}
      </>
    );
  };

  const renderMoreContractData = (_isShowMoreOpen, _contractData) => {
    if (!_isShowMoreOpen) {
      return null;
    }
    return (
      <View>
        {_isShowMoreOpen &&
          _map(_contractData, (item, index) => {
            const { key, value } = item;
            if (index > 1) {
              return <MyPlanInfoItem label={key} value={value} key={index} />;
            }
          })}
      </View>
    );
  };

  const renderShowMore = _contractData => {
    if (_contractData && _contractData.length > 2) {
      return (
        <TouchableWithoutFeedback onPress={handlePressShowMore}>
          <View style={styles.showMoreContainer}>
            <VFText
              i18nKey={
                isShowMoreOpen ? 'my_plan_primary_card_show_less' : 'my_plan_primary_card_show_more'
              }
              style={styles.showMoreText(theme)}
            />
          </View>
        </TouchableWithoutFeedback>
      );
    }
  };

  const handlePressShowMore = () => {
    UIManager.setLayoutAnimationEnabledExperimental &&
      UIManager.setLayoutAnimationEnabledExperimental(true);
    LayoutAnimation.configureNext(CustomLayoutAnimation);
    toggleShowMore(!isShowMoreOpen);
  };

  const renderDivider = () => <View style={styles.contentDivider(theme)} />;

  const planCardBodyComponents = [
    renderUsage(usageData),
    renderPrice(price, priceUnit),
    renderContractData(contractData),
    renderMyPlanCTAs(withUpgradePlanCTA, customPlanCTAs, onPressUpgradePlan),
    renderMoreContractData(isShowMoreOpen, contractData),
    renderShowMore(contractData),
  ].filter(item => item);

  const PlanCardBody = planCardBodyComponents.map((item, index) => {
    return (
      <Fragment key={index}>
        {index % 2 != 0 && renderDivider()}
        {item}
        {index % 2 != 0 && index != planCardBodyComponents.length - 1 && renderDivider()}
      </Fragment>
    );
  });

  return (
    <View style={[styles.cardContainerStyle(theme), style]}>
      <View style={styles.headerTitleViewStyle}>
        <VFText
          style={[styles.statusStyle(frameworkColors), statusStyle]}
          i18nKey={status}
          testKey={statusAccessibilityLabel}
        />
        {renderRightText()}
      </View>
      <View>
        <VFText
          style={[styles.titleStyle(theme), titleStyle]}
          i18nKey={title}
          testKey={titleAccessibilityLabel}
        />
      </View>
      <View style={styles.divider(theme)} />
      {children || PlanCardBody}
    </View>
  );
};

MyPlanCard.defaultProps = {
  theme: LightThemeColors,
  withUpgradePlanCTA: true,
  withUsagePercentage: true,
  percentageIndicatorShouldAnimate: false,
};

MyPlanCard.propTypes = {
  status: PropTypes.string,
  statusStyle: ViewPropTypes.style,
  statusAccessibilityLabel: ViewPropTypes.accessibilityLabel,
  price: PropTypes.number,
  priceUnit: PropTypes.string,
  title: PropTypes.string,
  titleStyle: ViewPropTypes.style,
  renewalDate: PropTypes.string,
  cardRightText: PropTypes.string,
  renewalDateStyle: ViewPropTypes.style,
  titleAccessibilityLabel: ViewPropTypes.accessibilityLabel,
  cardRightTextStyle: ViewPropTypes.style,
  usageData: PropTypes.arrayOf(
    PropTypes.shape({
      leftText: PropTypes.string,
      rightText: PropTypes.string,
      rightTextPlaceHolders: PropTypes.arrayOf(PropTypes.string),
      withPercentageText: PropTypes.bool,
      percentageIndicatorFillColor: ViewPropTypes.style,
      percentageIndicatorSecondaryColor: ViewPropTypes.style,
      percentageIndicatorContainerStyle: ViewPropTypes.style,
      percentageIndicatorShouldAnimate: ViewPropTypes.style,
      percentageValue: PropTypes.number,
      addUsageButtonTitle: PropTypes.string,
      onAddUsageButtonPress: PropTypes.func,
      key: PropTypes.string,
      usageItemLabel: PropTypes.string,
      usageValuesText: PropTypes.string,
      icon: PropTypes.string,
    }),
  ),
  contractData: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  onAddUsagePress: PropTypes.func,
  withUsagePercentage: PropTypes.bool,
  withUpgradePlanCTA: PropTypes.bool,
  percentageIndicatorFillColor: PropTypes.string,
  percentageIndicatorSecondaryColor: PropTypes.string,
  percentageIndicatorContainerStyle: ViewPropTypes.style,
  percentageIndicatorShouldAnimate: PropTypes.bool,
  images: PropTypes.object,
  customPlanCTAs: PropTypes.array,
  toggleAddUsageModal: PropTypes.func,
  onPressUpgradePlan: PropTypes.func,
  style: ViewPropTypes.style,
  children: PropTypes.node,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export default withTheme(MyPlanCard);
